(function () {
  var form = document.getElementById('gpform');
  var tag = document.querySelector('[data-variants]');
  if (!form || !tag) return;

  var variants = [];
  try { variants = JSON.parse(tag.textContent); } catch (e) { return; }
  if (!variants.length) return;

  var money = function (c) {
    var v = c / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  };

  var chips = Array.prototype.slice.call(form.querySelectorAll('.chip[data-opt]'));
  var groups = {};
  chips.forEach(function (c) { groups[c.dataset.opt] = groups[c.dataset.opt] || []; groups[c.dataset.opt].push(c); });
  var keys = Object.keys(groups).sort();
  var chosen = {};

  // Quantity axis = the option whose values are all plain numbers.
  var qtyKey = null;
  keys.forEach(function (k) {
    var allNum = groups[k].every(function (c) { return /^\s*\d[\d,]*\s*$/.test(c.dataset.val); });
    if (allNum && groups[k].length > 1 && !qtyKey) qtyKey = k;
  });

  var idInput = form.querySelector('[data-variantid]');
  var priceEl = form.parentElement.querySelector('[data-price]') || document.querySelector('[data-price]');
  var noteEl = document.querySelector('[data-pricenote]');
  var totalEl = form.querySelector('[data-total]');
  var buyBtn = form.querySelector('[data-buy]');
  var calc = form.querySelector('[data-calc]');
  var eachEl = form.querySelector('[data-each]');
  var qtyOut = form.querySelector('[data-qtyout]');
  var sizeOut = form.querySelector('[data-sizeout]');
  var runEl = form.querySelector('[data-runtotal]');
  var saveEl = form.querySelector('[data-savenote]');

  function matchVariant() {
    if (keys.length && keys.some(function (k) { return !chosen[k]; })) return null;
    var want = keys.map(function (k) { return chosen[k]; });
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < want.length; j++) {
        if (String(v.opts[j]) !== String(want[j])) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function baseUnit() {
    // Cheapest per-unit price across the quantity axis, for the savings note.
    var best = null;
    variants.forEach(function (v) {
      if (!qtyKey) return;
      var qi = keys.indexOf(qtyKey);
      var q = parseInt(String(v.opts[qi]).replace(/,/g, ''), 10);
      if (!q) return;
      var per = v.price / q;
      if (best === null || per < best) best = per;
    });
    return best;
  }

  function render() {
    keys.forEach(function (k) {
      var out = form.querySelector('[data-selected="' + k + '"]');
      if (out) out.textContent = chosen[k] || '—';
      groups[k].forEach(function (c) {
        var on = chosen[k] === c.dataset.val;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });

    var v = matchVariant();
    if (!v) {
      if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = keys.length ? 'Choose your options' : 'Add to cart & check out'; }
      if (calc) calc.hidden = true;
      return;
    }

    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (noteEl) noteEl.textContent = v.cap && v.cap > v.price ? 'was ' + money(v.cap) : 'your price';
    if (totalEl) totalEl.textContent = money(v.price);

    if (buyBtn) {
      buyBtn.disabled = !v.available;
      buyBtn.textContent = v.available ? 'Add to cart & check out' : 'Sold out';
    }

    if (calc && qtyKey) {
      var q = parseInt(String(chosen[qtyKey]).replace(/,/g, ''), 10);
      if (q > 0) {
        calc.hidden = false;
        var per = v.price / q;
        eachEl.textContent = '$' + (per / 100).toFixed(2);
        qtyOut.textContent = q.toLocaleString();
        if (sizeOut) {
          var sizeValue = '—';
          keys.forEach(function (k) {
            if (k !== qtyKey && chosen[k] && sizeValue === '—') sizeValue = chosen[k];
          });
          sizeOut.textContent = sizeValue;
        }
        runEl.textContent = money(v.price);
        var b = baseUnit();
        var worst = null;
        variants.forEach(function (x) {
          var qi = keys.indexOf(qtyKey);
          var qq = parseInt(String(x.opts[qi]).replace(/,/g, ''), 10);
          if (!qq) return;
          var pp = x.price / qq;
          if (worst === null || pp > worst) worst = pp;
        });
        if (worst && per < worst) {
          var pct = Math.round((1 - per / worst) * 100);
          saveEl.textContent = pct > 0 ? 'That is ' + pct + '% cheaper per sticker than the smallest run.' : '';
        } else {
          saveEl.textContent = 'Bump the quantity up to bring the per-sticker price down.';
        }
      } else {
        calc.hidden = true;
      }
    }
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      chosen[c.dataset.opt] = c.dataset.val;
      render();
      if (typeof syncProofShapeFromValue === 'function') syncProofShapeFromValue(c.dataset.val);
    });
  });

  // Preselect the first available variant's options.
  var first = variants.filter(function (v) { return v.available; })[0] || variants[0];
  keys.forEach(function (k, i) {
    var want = String(first.opts[i]);
    var hit = groups[k].filter(function (c) { return c.dataset.val === want; })[0];
    if (hit) chosen[k] = hit.dataset.val;
  });
  render();

  // ---- Scoped choice cards (builder + social platform picker) ----
  Array.prototype.slice.call(form.querySelectorAll('[data-choicegroup], [data-propgroup]')).forEach(function (group) {
    var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-choice], [data-prop]'));
    var input = group.querySelector('[data-choiceinput], [data-propinput]');
    var out = group.querySelector('[data-choiceout], [data-propout]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (other) {
          other.classList.remove('is-on');
          other.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-on');
        button.setAttribute('aria-pressed', 'true');
        if (input) input.value = button.dataset.val;
        if (out) out.textContent = button.dataset.val;

      });
    });
  });

  // ---- Social Media Decal live username / font preview ----
  // Desktop and mobile each have their own preview surface. Both stay synced
  // to the same username and font selection; the icon remains selection-only.
  var socialFontPreviews = Array.prototype.slice.call(document.querySelectorAll('[data-social-font-preview]'));
  if (socialFontPreviews.length) {
    var socialFontGroup = form.querySelector('[data-social-font-group]');
    var socialFontInput = form.querySelector('[data-social-font-input]');
    var socialFontOut = form.querySelector('[data-social-font-out]');
    var socialUsernameInput = form.querySelector('#gp-text');

    function socialFontKey(value) {
      var v = String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      if (v.indexOf('komika') > -1) return 'komika';
      if (v.indexOf('akira') > -1) return 'akira';
      if (v.indexOf('bebas') > -1) return 'bebas';
      if (v.indexOf('coolvetica') > -1) return 'coolvetica';
      if (v.indexOf('lemon') > -1) return 'lemonmilk';
      if (v.indexOf('monimer') > -1) return 'monimer';
      return 'komika';
    }

    function currentSocialFontValue() {
      if (socialFontInput && socialFontInput.value) return socialFontInput.value;
      if (socialFontGroup) {
        var on = socialFontGroup.querySelector('[data-social-font].is-on');
        if (on) return on.dataset.val || 'Komika Axis';
      }
      return 'Komika Axis';
    }

    function fitOneSocialPreview(preview) {
      var name = preview.querySelector('[data-social-font-preview-name]');
      var stage = preview.querySelector('[data-social-font-preview-stage]');
      if (!name || !stage || stage.clientWidth < 20) return;
      var mobile = preview.classList.contains('gp-social-preview-mobile');
      var base = mobile ? 43 : 58;
      var min = mobile ? 22 : 28;
      var available = Math.max(120, stage.clientWidth - (mobile ? 28 : 48));
      name.style.fontSize = base + 'px';
      window.requestAnimationFrame(function () {
        var width = name.getBoundingClientRect().width || 1;
        var fitted = Math.max(min, Math.min(base, base * Math.min(1, available / width)));
        name.style.fontSize = fitted.toFixed(2) + 'px';
      });
    }

    function fitSocialFontPreviews() {
      socialFontPreviews.forEach(fitOneSocialPreview);
    }

    function updateSocialFontPreview() {
      var fontValue = currentSocialFontValue();
      var typedUsername = socialUsernameInput ? String(socialUsernameInput.value || '').trim() : '';
      socialFontPreviews.forEach(function (preview) {
        var name = preview.querySelector('[data-social-font-preview-name]');
        var label = preview.querySelector('[data-social-font-preview-label]');
        if (name) {
          name.textContent = typedUsername || 'YOURUSERNAME';
          name.setAttribute('data-font', socialFontKey(fontValue));
        }
        if (label) label.textContent = fontValue;
      });
      if (socialFontOut) socialFontOut.textContent = fontValue;
      fitSocialFontPreviews();
    }

    if (socialFontGroup) {
      Array.prototype.slice.call(socialFontGroup.querySelectorAll('[data-social-font]')).forEach(function (button) {
        button.addEventListener('click', function () {
          Array.prototype.slice.call(socialFontGroup.querySelectorAll('[data-social-font]')).forEach(function (other) {
            var on = other === button;
            other.classList.toggle('is-on', on);
            other.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          var value = button.dataset.val || 'Komika Axis';
          if (socialFontInput) socialFontInput.value = value;
          if (socialFontOut) socialFontOut.textContent = value;
          updateSocialFontPreview();
        });
      });
    }

    if (socialUsernameInput) {
      socialUsernameInput.addEventListener('input', updateSocialFontPreview);
      socialUsernameInput.addEventListener('change', updateSocialFontPreview);
    }

    updateSocialFontPreview();
    window.addEventListener('resize', fitSocialFontPreviews);
    if (document.fonts) {
      document.fonts.ready.then(function () { window.requestAnimationFrame(updateSocialFontPreview); });
      if (document.fonts.addEventListener) {
        document.fonts.addEventListener('loadingdone', function () { window.requestAnimationFrame(updateSocialFontPreview); });
      }
    }
  }

  // ---- Vinyl Stickers artwork preview ----
  var proofRoot = form.querySelector('[data-proof-preview]');
  var proofModal = form.querySelector('[data-proof-modal]');
  var proofImage = null;
  var proofAutoBackgroundSample = null;
  var proofObjectUrl = null;
  var proofAutoOpened = false;
  var proofExistingStrokeDetection = null;
  var proofStrokeUserChoice = null;
  var proofSettings = { shape: 'edge', cutStyle: '', cutline: 'normal', color: '#ffffff', background: '#b7b9a6', removeBackground: false, removeExistingStroke: false };

  var proofOpenButton = form.querySelector('[data-proof-open]');

  function proofFriendlyColor(hex) {
    var h = String(hex || '').toLowerCase();
    if (h === '#ffffff') return 'White';
    if (h === '#111111') return 'Black';
    return h.toUpperCase();
  }

  function setProofChoice(selector, active) {
    if (!proofRoot) return;
    Array.prototype.slice.call(proofRoot.querySelectorAll(selector)).forEach(function (b) {
      var on = b === active;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }


  function setProofLauncherEnabled(enabled) {
    Array.prototype.slice.call(form.querySelectorAll('[data-proof-open]')).forEach(function (b) {
      b.disabled = !enabled;
      b.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    });
  }

  function openProofModal() {
    if (!proofModal || !proofRoot || proofRoot.hidden) return;
    proofModal.hidden = false;
    document.documentElement.classList.add('gp-proof-modal-open');
    document.body.classList.add('gp-proof-modal-open');
    window.requestAnimationFrame(function () { proofModal.classList.add('is-open'); drawProof(); });
  }

  function closeProofModal() {
    if (!proofModal) return;
    proofModal.classList.remove('is-open');
    document.documentElement.classList.remove('gp-proof-modal-open');
    document.body.classList.remove('gp-proof-modal-open');
    window.setTimeout(function () {
      if (!proofModal.classList.contains('is-open')) proofModal.hidden = true;
    }, 180);
  }

  function setProofDecision(value, copy) {
    var input = form.querySelector('[data-proof-decision-input]');
    var status = form.querySelector('[data-proof-decision-status]');
    if (input) input.value = value;
    if (status) status.textContent = copy;
  }

  // Save the exact live proof as a second Shopify line-item file property.
  // The customer's original Artwork upload stays untouched.
  function captureApprovedPreview() {
    if (!proofRoot || !proofImage) return false;
    var canvas = proofRoot.querySelector('[data-proof-canvas]');
    var fileInput = form.querySelector('[data-proof-file]');
    if (!canvas || !fileInput || !window.DataTransfer || !window.File) return false;

    try {
      // Build the cart/order attachment as a clean proof with NO green cut-path overlay.
      // The live proof canvas still shows the cut path for the customer.
      drawProof(false);
      var exported = document.createElement('canvas');
      exported.width = canvas.width;
      exported.height = canvas.height;
      var ex = exported.getContext('2d');
      ex.fillStyle = proofSettings.background || '#b7b9a6';
      ex.fillRect(0, 0, exported.width, exported.height);
      ex.drawImage(canvas, 0, 0);
      drawProof(true);

      var dataUrl = exported.toDataURL('image/png');
      var parts = dataUrl.split(',');
      var mime = (parts[0].match(/data:([^;]+)/) || [null, 'image/png'])[1];
      var bytes = atob(parts[1]);
      var array = new Uint8Array(bytes.length);
      for (var i = 0; i < bytes.length; i++) array[i] = bytes.charCodeAt(i);

      var previewFile = new File([array], 'clean-sticker-preview.png', { type: mime });
      var transfer = new DataTransfer();
      transfer.items.add(previewFile);
      fileInput.files = transfer.files;
      return true;
    } catch (e) {
      return false;
    }
  }

  function clearApprovedPreview() {
    var fileInput = form.querySelector('[data-proof-file]');
    if (!fileInput || !window.DataTransfer) return;
    try { fileInput.files = new DataTransfer().files; } catch (e) {}
  }

  function shapeFromValue(value, hinted) {
    var v = String(value || '').toLowerCase();
    var h = String(hinted || '').toLowerCase();
    if (h.indexOf('circle') > -1 || v.indexOf('circle') > -1 || v.indexOf('round') > -1) return 'circle';
    if (h.indexOf('oval') > -1 || v.indexOf('oval') > -1) return 'oval';
    if (h.indexOf('rectangle') > -1 || v.indexOf('rectangle') > -1 || v.indexOf('rect') > -1) return 'rect';
    if (h.indexOf('square') > -1 || v.indexOf('square') > -1) return 'square';
    if (h.indexOf('kiss') > -1 || v.indexOf('kiss') > -1) return 'kiss';
    return 'edge';
  }

  function syncProofShapeFromValue(value, hinted) {
    if (!proofRoot || !value) return;
    proofSettings.cutStyle = String(value);
    proofSettings.shape = shapeFromValue(value, hinted);
    Array.prototype.slice.call(proofRoot.querySelectorAll('[data-proof-cutstyle-value]')).forEach(function (b) {
      var on = String(b.dataset.proofCutstyleValue) === String(value);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    // Background removal is automatic only for Cut to Shape / edge-cut previews.
    // Geometric preview shapes keep the original artwork background intact.
    setBackgroundRemoval(proofSettings.shape === 'edge');
    updateBackgroundControl();
    drawProof();
  }

  function buildProofCutStyles() {
    if (!proofRoot) return;
    var host = proofRoot.querySelector('[data-proof-cutstyles]');
    var wrap = proofRoot.querySelector('[data-proof-cutstyle-wrap]');
    if (!host) return;
    var source = Array.prototype.slice.call(form.querySelectorAll('[data-cut-style-option]'));
    if (!source.length) { if (wrap) wrap.hidden = true; return; }
    host.innerHTML = '';
    source.forEach(function (chip) {
      var b = document.createElement('button');
      var iconShape = shapeFromValue(chip.dataset.val, chip.dataset.previewShape);
      b.type = 'button';
      b.className = 'gp-proof-cutstyle';
      b.dataset.proofCutstyleValue = chip.dataset.val;
      b.dataset.proofShapeHint = chip.dataset.previewShape || '';
      b.dataset.proofShape = iconShape;
      b.innerHTML = '<span class="gp-proof-cut-icon gp-proof-cut-icon--' + iconShape + '" aria-hidden="true"></span><span>' + chip.dataset.val.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</span>';
      b.addEventListener('click', function () {
        chip.click();
        syncProofShapeFromValue(chip.dataset.val, chip.dataset.previewShape);
      });
      host.appendChild(b);
    });
    var selected = source.filter(function (chip) { return chip.classList.contains('is-on'); })[0] || source[0];
    if (selected) syncProofShapeFromValue(selected.dataset.val, selected.dataset.previewShape);
  }

  function roundedRectPath(ctx, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function colorDistance(r, g, b, sample) {
    var dr = r - sample[0], dg = g - sample[1], db = b - sample[2];
    return Math.sqrt(dr * dr + dg * dg + db * db);
  }


  function rgbToHex(r, g, b) {
    function h(v) { return Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0'); }
    return '#' + h(r) + h(g) + h(b);
  }

  function sampleEdgeBackgroundFromImage(img) {
    var test = document.createElement('canvas');
    test.width = 84; test.height = 84;
    var tc = test.getContext('2d', { willReadFrequently: true });
    tc.imageSmoothingEnabled = true;
    tc.imageSmoothingQuality = 'high';
    tc.drawImage(img, 0, 0, 84, 84);
    return sampleEdgeBackgroundFromCanvas(test);
  }

  function sampleEdgeBackgroundFromCanvas(canvas) {
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    var w = canvas.width, h = canvas.height;
    if (!w || !h) return null;
    var d = ctx.getImageData(0, 0, w, h).data;
    var pts = [];
    var fractions = [0, .06, .12, .2, .32, .5, .68, .8, .88, .94, 1];
    fractions.forEach(function (f) {
      var x = Math.min(w - 1, Math.max(0, Math.round((w - 1) * f)));
      var y = Math.min(h - 1, Math.max(0, Math.round((h - 1) * f)));
      pts.push([x,0],[x,h-1],[0,y],[w-1,y]);
    });

    var samples = [];
    pts.forEach(function (pt) {
      var p = (pt[1] * w + pt[0]) * 4;
      if (d[p + 3] > 180) samples.push([d[p], d[p+1], d[p+2], d[p+3]]);
    });
    if (samples.length < 4) return null;

    // Quantize edge pixels and choose the most common color family. This resets for every upload,
    // so the border always follows the current artwork instead of inheriting a previous file's color.
    var bins = Object.create(null);
    samples.forEach(function (c) {
      var qr = Math.round(c[0] / 24) * 24;
      var qg = Math.round(c[1] / 24) * 24;
      var qb = Math.round(c[2] / 24) * 24;
      var k = qr + ',' + qg + ',' + qb;
      if (!bins[k]) bins[k] = [];
      bins[k].push(c);
    });
    var bestKey = null, bestCount = 0;
    Object.keys(bins).forEach(function (k) {
      if (bins[k].length > bestCount) { bestKey = k; bestCount = bins[k].length; }
    });
    if (!bestKey) return null;

    var seedGroup = bins[bestKey];
    var sr=0,sg=0,sb=0;
    seedGroup.forEach(function(c){ sr+=c[0]; sg+=c[1]; sb+=c[2]; });
    sr/=seedGroup.length; sg/=seedGroup.length; sb/=seedGroup.length;

    var close = samples.filter(function (c) { return colorDistance(c[0], c[1], c[2], [sr,sg,sb,255]) <= 64; });
    if (!close.length) close = seedGroup;
    var r=0,g=0,b=0;
    close.forEach(function (c) { r += c[0]; g += c[1]; b += c[2]; });
    r /= close.length; g /= close.length; b /= close.length;
    return { rgb:[r,g,b,255], hex:rgbToHex(r,g,b), confidence:close.length / samples.length };
  }


  function applyAutoBorderColor(hex) {
    if (!proofRoot || !hex) return;
    proofSettings.color = hex.toLowerCase();
    var preset = null;
    Array.prototype.slice.call(proofRoot.querySelectorAll('[data-proof-color]')).forEach(function (b) {
      var isMatch = String(b.dataset.proofColor || '').toLowerCase() === proofSettings.color;
      b.classList.toggle('is-on', isMatch);
      b.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
      if (isMatch) preset = b;
    });
    var custom = proofRoot.querySelector('[data-proof-color-custom]');
    if (custom) {
      custom.value = proofSettings.color;
      if (custom.parentElement) custom.parentElement.classList.toggle('is-on', !preset);
    }
    var prop = proofRoot.querySelector('[data-proof-prop-color]');
    if (prop) prop.value = proofFriendlyColor(proofSettings.color) + ' (auto-matched from artwork)';
  }

  function removeMatchingBackgroundEverywhere(canvas, tolerance) {
    var sample = proofAutoBackgroundSample || sampleEdgeBackgroundFromCanvas(canvas);
    if (!sample) { removeConnectedBackground(canvas, tolerance); return; }
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    var w = canvas.width, h = canvas.height;
    var img = ctx.getImageData(0, 0, w, h);
    var d = img.data;
    var bg = sample.rgb;
    var feather = 18;
    for (var i = 0; i < w * h; i++) {
      var p = i * 4;
      if (d[p + 3] < 10) continue;
      var dist = colorDistance(d[p], d[p+1], d[p+2], bg);
      if (dist <= tolerance) d[p + 3] = 0;
      else if (dist <= tolerance + feather) d[p + 3] = Math.round(d[p + 3] * ((dist - tolerance) / feather));
    }
    ctx.putImageData(img, 0, 0);
  }

  // Removes a solid background that touches the outside edge of the uploaded artwork.
  // It samples the artwork corners, then flood-fills only connected pixels close to those colors.
  function removeConnectedBackground(canvas, tolerance) {
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    var w = canvas.width, h = canvas.height;
    if (!w || !h) return;
    var img = ctx.getImageData(0, 0, w, h);
    var d = img.data;
    var corners = [[0,0],[w-1,0],[0,h-1],[w-1,h-1]].map(function (pt) {
      var p = (pt[1] * w + pt[0]) * 4;
      return [d[p], d[p+1], d[p+2], d[p+3]];
    }).filter(function (c) { return c[3] > 220; });
    if (!corners.length) return;

    var seen = new Uint8Array(w * h);
    var queue = new Int32Array(w * h);
    var head = 0, tail = 0;
    var feather = 24;
    function bestDistance(i) {
      var p = i * 4;
      if (d[p + 3] < 10) return 9999;
      var best = 9999;
      for (var c = 0; c < corners.length; c++) best = Math.min(best, colorDistance(d[p], d[p+1], d[p+2], corners[c]));
      return best;
    }
    function push(i) {
      if (i < 0 || i >= w * h || seen[i]) return;
      var dist = bestDistance(i);
      if (dist > tolerance + feather) return;
      seen[i] = 1;
      queue[tail++] = i;
    }
    for (var x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
    for (var y = 0; y < h; y++) { push(y * w); push(y * w + (w - 1)); }
    while (head < tail) {
      var i = queue[head++];
      var x0 = i % w, y0 = (i / w) | 0;
      var dist = bestDistance(i);
      var p = i * 4;
      if (dist <= tolerance) d[p + 3] = 0;
      else d[p + 3] = Math.round(d[p + 3] * Math.max(0, Math.min(1, (dist - tolerance) / feather)));
      if (x0 > 0) push(i - 1);
      if (x0 + 1 < w) push(i + 1);
      if (y0 > 0) push(i - w);
      if (y0 + 1 < h) push(i + w);
    }
    ctx.putImageData(img, 0, 0);
  }

  // Detect a baked-in outer outline without confusing a solid-color logo for a stroke.
  // Only a color region connected to the transparent outside edge is considered. A candidate
  // is rejected when it occupies too much of the artwork or continues too deeply into the design.
  function analyzeExistingOuterStroke(canvas) {
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    var w = canvas.width, h = canvas.height;
    if (!w || !h || Math.min(w, h) < 12) return null;
    var img = ctx.getImageData(0, 0, w, h);
    var d = img.data;
    var total = w * h;
    var opaque = new Uint8Array(total);
    var opaqueCount = 0;
    var boundary = [];
    var alphaThreshold = 36;

    for (var i = 0; i < total; i++) {
      if (d[i * 4 + 3] > alphaThreshold) { opaque[i] = 1; opaqueCount++; }
    }
    if (opaqueCount < 24) return null;

    function isOutsideOrClear(x, y) {
      if (x < 0 || y < 0 || x >= w || y >= h) return true;
      return !opaque[y * w + x];
    }
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      var idx = y * w + x;
      if (!opaque[idx]) continue;
      if (isOutsideOrClear(x - 1, y) || isOutsideOrClear(x + 1, y) || isOutsideOrClear(x, y - 1) || isOutsideOrClear(x, y + 1)) boundary.push(idx);
    }
    if (boundary.length < Math.max(18, Math.round(Math.min(w, h) * .28))) return null;

    // Find the dominant color family along the actual transparent/opaque boundary.
    var bins = Object.create(null);
    boundary.forEach(function (idx) {
      var p = idx * 4;
      var qr = Math.round(d[p] / 20) * 20;
      var qg = Math.round(d[p + 1] / 20) * 20;
      var qb = Math.round(d[p + 2] / 20) * 20;
      var key = qr + ',' + qg + ',' + qb;
      if (!bins[key]) bins[key] = [];
      bins[key].push(idx);
    });
    var best = null, bestCount = 0;
    Object.keys(bins).forEach(function (key) {
      if (bins[key].length > bestCount) { best = bins[key]; bestCount = bins[key].length; }
    });
    if (!best || best.length < 12) return null;

    var rr = 0, gg = 0, bb = 0;
    best.forEach(function (idx) { var p = idx * 4; rr += d[p]; gg += d[p + 1]; bb += d[p + 2]; });
    rr /= best.length; gg /= best.length; bb /= best.length;
    var seed = [rr, gg, bb, 255];
    var closeBoundary = boundary.filter(function (idx) {
      var p = idx * 4;
      return colorDistance(d[p], d[p + 1], d[p + 2], seed) <= 58;
    });
    var confidence = closeBoundary.length / boundary.length;
    if (confidence < .46) return null;

    // Flood the matching color inward from the outside boundary. Unlike a simple erosion,
    // this follows only the suspected outline color, so interior artwork of other colors stays intact.
    var seen = new Uint8Array(total);
    var depth = new Uint16Array(total);
    var queue = new Int32Array(total);
    var head = 0, tail = 0;
    var removeMask = new Uint8Array(total);
    var tolerance = 66;
    var candidateCount = 0;
    var maxDepth = 0;

    function matches(idx) {
      if (idx < 0 || idx >= total || !opaque[idx]) return false;
      var p = idx * 4;
      return colorDistance(d[p], d[p + 1], d[p + 2], seed) <= tolerance;
    }
    closeBoundary.forEach(function (idx) {
      if (seen[idx] || !matches(idx)) return;
      seen[idx] = 1; depth[idx] = 1; queue[tail++] = idx;
    });
    while (head < tail) {
      var idx = queue[head++];
      removeMask[idx] = 1;
      candidateCount++;
      var dep = depth[idx];
      if (dep > maxDepth) maxDepth = dep;
      var x = idx % w, y = (idx / w) | 0;
      var ns = [];
      if (x > 0) ns.push(idx - 1);
      if (x + 1 < w) ns.push(idx + 1);
      if (y > 0) ns.push(idx - w);
      if (y + 1 < h) ns.push(idx + w);
      for (var n = 0; n < ns.length; n++) {
        var ni = ns[n];
        if (seen[ni] || !matches(ni)) continue;
        seen[ni] = 1; depth[ni] = dep + 1; queue[tail++] = ni;
      }
    }

    var coverage = candidateCount / opaqueCount;
    var allowedDepth = Math.max(5, Math.min(42, Math.round(Math.min(w, h) * .10)));
    // A true outer stroke is a minority shell. A solid silhouette or a large flat-color subject
    // usually occupies too much area or continues far deeper than a normal outline.
    if (coverage < .012 || coverage > .42 || maxDepth > allowedDepth) return null;

    return {
      rgb: seed,
      hex: rgbToHex(seed[0], seed[1], seed[2]),
      confidence: confidence,
      coverage: coverage,
      maxDepth: maxDepth,
      mask: removeMask,
      width: w,
      height: h
    };
  }

  function removeExistingOuterStroke(canvas, analysis) {
    analysis = analysis || analyzeExistingOuterStroke(canvas);
    if (!analysis || analysis.width !== canvas.width || analysis.height !== canvas.height) return false;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    var img = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var d = img.data;
    var mask = analysis.mask;
    var w = canvas.width, h = canvas.height;

    for (var i = 0; i < mask.length; i++) if (mask[i]) d[i * 4 + 3] = 0;

    // Feather only the one-pixel fringe around the removed outline to avoid a colored halo.
    var fringe = new Uint8Array(mask.length);
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      var idx = y * w + x;
      if (!mask[idx]) continue;
      if (x > 0 && !mask[idx - 1]) fringe[idx - 1] = 1;
      if (x + 1 < w && !mask[idx + 1]) fringe[idx + 1] = 1;
      if (y > 0 && !mask[idx - w]) fringe[idx - w] = 1;
      if (y + 1 < h && !mask[idx + w]) fringe[idx + w] = 1;
    }
    for (var j = 0; j < fringe.length; j++) if (fringe[j]) {
      var p = j * 4;
      var dist = colorDistance(d[p], d[p + 1], d[p + 2], analysis.rgb);
      if (dist <= 82) d[p + 3] = Math.round(d[p + 3] * Math.max(0, Math.min(1, (dist - 58) / 24)));
    }
    ctx.putImageData(img, 0, 0);
    return true;
  }

  function buildStrokeDetectionCanvas() {
    if (!proofImage) return null;
    var maxDim = 420;
    var scale = Math.min(1, maxDim / Math.max(proofImage.naturalWidth || 1, proofImage.naturalHeight || 1));
    var w = Math.max(1, Math.round((proofImage.naturalWidth || 1) * scale));
    var h = Math.max(1, Math.round((proofImage.naturalHeight || 1) * scale));
    var canvas = document.createElement('canvas'); canvas.width = w; canvas.height = h;
    var cx = canvas.getContext('2d', { willReadFrequently: true });
    cx.imageSmoothingEnabled = true; cx.imageSmoothingQuality = 'high';
    cx.drawImage(proofImage, 0, 0, w, h);
    if (proofSettings.removeBackground) removeMatchingBackgroundEverywhere(canvas, 46);
    return trimCanvasToAlpha(canvas, 2);
  }

  function updateExistingStrokeControl() {
    if (!proofRoot) return;
    var wrap = proofRoot.querySelector('[data-proof-stroke-control]');
    var btn = proofRoot.querySelector('[data-remove-existing-stroke]');
    var status = proofRoot.querySelector('[data-stroke-status]');
    var prop = proofRoot.querySelector('[data-proof-prop-stroke]');
    var detected = !!proofExistingStrokeDetection;
    if (wrap) wrap.hidden = !detected;
    if (btn) {
      btn.disabled = !detected;
      btn.classList.toggle('is-on', detected && proofSettings.removeExistingStroke);
      btn.setAttribute('aria-pressed', detected && proofSettings.removeExistingStroke ? 'true' : 'false');
    }
    if (status) status.textContent = !detected ? 'No outer outline detected' : (proofSettings.removeExistingStroke ? 'Detected · cleaning it up' : 'Detected · keeping original');
    if (prop) prop.value = !detected ? 'No existing outer outline detected' : (proofSettings.removeExistingStroke ? 'Remove detected outer outline' : 'Keep detected outer outline');
  }

  function refreshExistingStrokeDetection(resetChoice) {
    if (resetChoice) proofStrokeUserChoice = null;
    var test = buildStrokeDetectionCanvas();
    proofExistingStrokeDetection = test ? analyzeExistingOuterStroke(test) : null;
    if (!proofExistingStrokeDetection) proofSettings.removeExistingStroke = false;
    else if (proofStrokeUserChoice === null) proofSettings.removeExistingStroke = true;
    else proofSettings.removeExistingStroke = !!proofStrokeUserChoice;
    updateExistingStrokeControl();
  }

  function setExistingStrokeRemoval(on) {
    proofStrokeUserChoice = !!on;
    proofSettings.removeExistingStroke = !!on && !!proofExistingStrokeDetection;
    updateExistingStrokeControl();
    drawProof();
  }

  function imageLikelyHasSolidBackground(img) {
    var sample = sampleEdgeBackgroundFromImage(img);
    return !!(sample && sample.confidence >= .55);
  }

  // Build a reduced/smoothed silhouette for the visual cut path.
  // The artwork is sampled at low resolution, denoised, then dilated so tiny
  // bumps and micro-details do not create an overly jagged contour.
  function buildSimplifiedMask(art, sampleSize) {
    var W = art.width, H = art.height;
    // Use a larger, aspect-ratio-safe sample so portrait art does not collapse to a tiny mask.
    var maxDim = Math.max(180, Math.round(sampleSize || 240));
    var scale = W >= H ? (maxDim / Math.max(1, W)) : (maxDim / Math.max(1, H));
    var sw = Math.max(1, Math.round(W * scale));
    var sh = Math.max(1, Math.round(H * scale));
    var c = document.createElement('canvas'); c.width = sw; c.height = sh;
    var cx = c.getContext('2d', { willReadFrequently: true });
    cx.imageSmoothingEnabled = true;
    cx.imageSmoothingQuality = 'high';
    cx.drawImage(art, 0, 0, sw, sh);
    var img = cx.getImageData(0, 0, sw, sh);
    var src = new Uint8Array(sw * sh);
    for (var i = 0; i < src.length; i++) src[i] = img.data[i * 4 + 3] > 40 ? 1 : 0;

    // Two majority-filter passes remove tiny spikes, pinholes and isolated pixels.
    for (var pass = 0; pass < 2; pass++) {
      var out = new Uint8Array(src.length);
      for (var y = 0; y < sh; y++) for (var x = 0; x < sw; x++) {
        var count = 0, total = 0;
        for (var yy = -1; yy <= 1; yy++) for (var xx = -1; xx <= 1; xx++) {
          var nx = x + xx, ny = y + yy;
          if (nx < 0 || ny < 0 || nx >= sw || ny >= sh) continue;
          total++; count += src[ny * sw + nx];
        }
        out[y * sw + x] = count >= Math.ceil(total * .45) ? 1 : 0;
      }
      src = out;
    }
    return { data: src, width: sw, height: sh };
  }

  function dilateMask(mask, radius) {
    var sw = mask.width, sh = mask.height, src = mask.data;
    var out = new Uint8Array(src.length);
    radius = Math.max(1, Math.round(radius));
    var r2 = radius * radius;
    for (var y = 0; y < sh; y++) for (var x = 0; x < sw; x++) {
      if (!src[y * sw + x]) continue;
      for (var yy = -radius; yy <= radius; yy++) for (var xx = -radius; xx <= radius; xx++) {
        if (xx * xx + yy * yy > r2) continue;
        var nx = x + xx, ny = y + yy;
        if (nx >= 0 && ny >= 0 && nx < sw && ny < sh) out[ny * sw + nx] = 1;
      }
    }
    return { data: out, width: sw, height: sh };
  }


  function erodeMask(mask, radius) {
    var sw = mask.width, sh = mask.height, src = mask.data;
    var out = new Uint8Array(src.length);
    radius = Math.max(1, Math.round(radius));
    var r2 = radius * radius;
    for (var y = 0; y < sh; y++) for (var x = 0; x < sw; x++) {
      var keep = 1;
      for (var yy = -radius; yy <= radius && keep; yy++) for (var xx = -radius; xx <= radius; xx++) {
        if (xx * xx + yy * yy > r2) continue;
        var nx = x + xx, ny = y + yy;
        if (nx < 0 || ny < 0 || nx >= sw || ny >= sh || !src[ny * sw + nx]) { keep = 0; break; }
      }
      out[y * sw + x] = keep;
    }
    return { data: out, width: sw, height: sh };
  }

  function subtractMask(outer, inner) {
    var out = new Uint8Array(outer.data.length);
    for (var i = 0; i < out.length; i++) out[i] = outer.data[i] && !inner.data[i] ? 1 : 0;
    return { data: out, width: outer.width, height: outer.height };
  }

  function buildClosedMask(mask, radius) {
    return erodeMask(dilateMask(mask, radius), radius);
  }


  function fillMaskHoles(mask) {
    var sw = mask.width, sh = mask.height, src = mask.data;
    var visited = new Uint8Array(src.length);
    var queue = new Int32Array(src.length);
    var head = 0, tail = 0;
    function push(i) {
      if (i < 0 || i >= src.length || visited[i] || src[i]) return;
      visited[i] = 1;
      queue[tail++] = i;
    }
    for (var x = 0; x < sw; x++) { push(x); push((sh - 1) * sw + x); }
    for (var y = 0; y < sh; y++) { push(y * sw); push(y * sw + (sw - 1)); }
    while (head < tail) {
      var i = queue[head++];
      var x0 = i % sw, y0 = (i / sw) | 0;
      if (x0 > 0) push(i - 1);
      if (x0 + 1 < sw) push(i + 1);
      if (y0 > 0) push(i - sw);
      if (y0 + 1 < sh) push(i + sw);
    }
    var out = new Uint8Array(src.length);
    for (var i = 0; i < src.length; i++) out[i] = src[i] || !visited[i] ? 1 : 0;
    return { data: out, width: sw, height: sh };
  }

  function blurThresholdMask(mask, blurPx, threshold) {
    var c = document.createElement('canvas'); c.width = mask.width; c.height = mask.height;
    var cx = c.getContext('2d');
    var im = cx.createImageData(mask.width, mask.height);
    for (var i = 0; i < mask.data.length; i++) if (mask.data[i]) im.data[i * 4 + 3] = 255;
    cx.putImageData(im, 0, 0);

    var outCanvas = document.createElement('canvas'); outCanvas.width = mask.width; outCanvas.height = mask.height;
    var ox = outCanvas.getContext('2d', { willReadFrequently: true });
    ox.filter = 'blur(' + (blurPx || 1.5) + 'px)';
    ox.drawImage(c, 0, 0);
    ox.filter = 'none';
    var data = ox.getImageData(0, 0, mask.width, mask.height).data;
    var out = new Uint8Array(mask.data.length);
    var t = threshold == null ? 100 : threshold;
    for (var j = 0; j < out.length; j++) out[j] = data[j * 4 + 3] >= t ? 1 : 0;
    return { data: out, width: mask.width, height: mask.height };
  }

  function maskCanvas(mask, fill) {
    var c = document.createElement('canvas'); c.width = mask.width; c.height = mask.height;
    var cx = c.getContext('2d');
    var im = cx.createImageData(mask.width, mask.height);
    var rgb = /^#([0-9a-f]{6})$/i.exec(fill || '#ffffff');
    var n = rgb ? parseInt(rgb[1], 16) : 0xffffff;
    var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    for (var i = 0; i < mask.data.length; i++) if (mask.data[i]) {
      var p = i * 4; im.data[p] = r; im.data[p+1] = g; im.data[p+2] = b; im.data[p+3] = 255;
    }
    cx.putImageData(im, 0, 0);
    return c;
  }

  function hexToRgb(fill, fallback) {
    var rgb = /^#([0-9a-f]{6})$/i.exec(fill || fallback || '#ffffff');
    var n = rgb ? parseInt(rgb[1], 16) : 0xffffff;
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }

  function maskCanvasSolid(mask, primary) {
    var c = document.createElement('canvas'); c.width = mask.width; c.height = mask.height;
    var cx = c.getContext('2d');
    var im = cx.createImageData(mask.width, mask.height);
    var a = hexToRgb(primary || '#39ff14');
    for (var i = 0; i < mask.data.length; i++) {
      if (!mask.data[i]) continue;
      var p = i * 4;
      im.data[p] = a[0]; im.data[p+1] = a[1]; im.data[p+2] = a[2]; im.data[p+3] = 255;
    }
    cx.putImageData(im, 0, 0);
    return c;
  }


  function maskCanvasDashed(mask, primary) {
    var c = document.createElement('canvas'); c.width = mask.width; c.height = mask.height;
    var cx = c.getContext('2d');
    var im = cx.createImageData(mask.width, mask.height);
    var a = hexToRgb(primary || '#39ff14');
    var dash = 5, gap = 4, period = dash + gap;
    for (var y = 0; y < mask.height; y++) {
      for (var x = 0; x < mask.width; x++) {
        var i = y * mask.width + x;
        if (!mask.data[i]) continue;
        if (((x + y) % period) >= dash) continue;
        var p = i * 4;
        im.data[p] = a[0]; im.data[p+1] = a[1]; im.data[p+2] = a[2]; im.data[p+3] = 255;
      }
    }
    cx.putImageData(im, 0, 0);
    return c;
  }


  function trimCanvasToAlpha(canvas, padding) {
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    var w = canvas.width, h = canvas.height;
    var data = ctx.getImageData(0, 0, w, h).data;
    var minX = w, minY = h, maxX = -1, maxY = -1;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      var a = data[(y * w + x) * 4 + 3];
      if (a <= 12) continue;
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (x > maxX) maxX = x;
      if (y > maxY) maxY = y;
    }
    if (maxX < minX || maxY < minY) return canvas;
    var pad = Math.max(0, padding || 0);
    minX = Math.max(0, minX - pad); minY = Math.max(0, minY - pad);
    maxX = Math.min(w - 1, maxX + pad); maxY = Math.min(h - 1, maxY + pad);
    var tw = Math.max(1, maxX - minX + 1), th = Math.max(1, maxY - minY + 1);
    var out = document.createElement('canvas'); out.width = tw; out.height = th;
    out.getContext('2d').drawImage(canvas, minX, minY, tw, th, 0, 0, tw, th);
    return out;
  }

  function fitCanvasToBox(canvas, maxW, maxH) {
    var scale = Math.min(maxW / canvas.width, maxH / canvas.height);
    var w = Math.max(1, Math.round(canvas.width * scale));
    var h = Math.max(1, Math.round(canvas.height * scale));
    var out = document.createElement('canvas'); out.width = w; out.height = h;
    var cx = out.getContext('2d');
    cx.imageSmoothingEnabled = true;
    cx.drawImage(canvas, 0, 0, w, h);
    return out;
  }


  function polygonArea(points) {
    var area = 0;
    for (var i = 0; i < points.length; i++) {
      var a = points[i], b = points[(i + 1) % points.length];
      area += a[0] * b[1] - b[0] * a[1];
    }
    return area / 2;
  }

  function pruneCollinear(points) {
    if (!points || points.length < 3) return points || [];
    var out = [];
    for (var i = 0; i < points.length; i++) {
      var prev = points[(i - 1 + points.length) % points.length];
      var curr = points[i];
      var next = points[(i + 1) % points.length];
      var sameX = Math.abs(prev[0] - curr[0]) < 0.0001 && Math.abs(curr[0] - next[0]) < 0.0001;
      var sameY = Math.abs(prev[1] - curr[1]) < 0.0001 && Math.abs(curr[1] - next[1]) < 0.0001;
      if (sameX || sameY) continue;
      out.push(curr);
    }
    return out.length ? out : points;
  }

  function perpendicularDistance(point, lineStart, lineEnd) {
    var x = point[0], y = point[1], x1 = lineStart[0], y1 = lineStart[1], x2 = lineEnd[0], y2 = lineEnd[1];
    var dx = x2 - x1, dy = y2 - y1;
    if (dx === 0 && dy === 0) return Math.hypot(x - x1, y - y1);
    var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
    var px = x1 + t * dx, py = y1 + t * dy;
    return Math.hypot(x - px, y - py);
  }

  function simplifyPathRDP(points, epsilon) {
    if (!points || points.length < 3) return points || [];
    var closed = points.slice();
    closed.push(points[0]);
    function rdp(pts) {
      if (pts.length <= 2) return pts.slice();
      var maxDist = 0, index = 0;
      for (var i = 1; i < pts.length - 1; i++) {
        var dist = perpendicularDistance(pts[i], pts[0], pts[pts.length - 1]);
        if (dist > maxDist) { maxDist = dist; index = i; }
      }
      if (maxDist > epsilon) {
        var left = rdp(pts.slice(0, index + 1));
        var right = rdp(pts.slice(index));
        return left.slice(0, -1).concat(right);
      }
      return [pts[0], pts[pts.length - 1]];
    }
    var simplified = rdp(closed).slice(0, -1);
    return simplified.length >= 3 ? simplified : points;
  }

  function chaikinClosed(points, iterations) {
    var pts = points.slice();
    for (var iter = 0; iter < (iterations || 0); iter++) {
      if (pts.length < 3) break;
      var out = [];
      for (var i = 0; i < pts.length; i++) {
        var p0 = pts[i], p1 = pts[(i + 1) % pts.length];
        out.push([p0[0] * 0.75 + p1[0] * 0.25, p0[1] * 0.75 + p1[1] * 0.25]);
        out.push([p0[0] * 0.25 + p1[0] * 0.75, p0[1] * 0.25 + p1[1] * 0.75]);
      }
      pts = out;
    }
    return pts;
  }

  function traceMaskOuterPath(mask) {
    var sw = mask.width, sh = mask.height, src = mask.data;
    var nextMap = Object.create(null);
    function key(x, y) { return x + ',' + y; }
    function addEdge(x1, y1, x2, y2) {
      var k = key(x1, y1);
      if (!nextMap[k]) nextMap[k] = [];
      nextMap[k].push([x2, y2]);
    }
    for (var y = 0; y < sh; y++) for (var x = 0; x < sw; x++) {
      if (!src[y * sw + x]) continue;
      if (y === 0 || !src[(y - 1) * sw + x]) addEdge(x, y, x + 1, y);
      if (x === sw - 1 || !src[y * sw + (x + 1)]) addEdge(x + 1, y, x + 1, y + 1);
      if (y === sh - 1 || !src[(y + 1) * sw + x]) addEdge(x + 1, y + 1, x, y + 1);
      if (x === 0 || !src[y * sw + (x - 1)]) addEdge(x, y + 1, x, y);
    }
    var used = Object.create(null), loops = [];
    Object.keys(nextMap).forEach(function (startKey) {
      var outs = nextMap[startKey] || [];
      outs.forEach(function (firstNext) {
        var edgeKey = startKey + '|' + firstNext[0] + ',' + firstNext[1];
        if (used[edgeKey]) return;
        var parts = startKey.split(',');
        var start = [parseFloat(parts[0]), parseFloat(parts[1])];
        var current = start.slice();
        var next = firstNext.slice();
        var loop = [start.slice()];
        var guard = 0;
        while (guard++ < sw * sh * 8) {
          var curKey = current[0] + ',' + current[1];
          var eKey = curKey + '|' + next[0] + ',' + next[1];
          if (used[eKey]) break;
          used[eKey] = 1;
          current = next.slice();
          loop.push(current.slice());
          if (current[0] === start[0] && current[1] === start[1]) break;
          var out = nextMap[current[0] + ',' + current[1]] || [];
          var chosen = null;
          for (var i = 0; i < out.length; i++) {
            var cand = out[i];
            var candKey = current[0] + ',' + current[1] + '|' + cand[0] + ',' + cand[1];
            if (!used[candKey]) { chosen = cand; break; }
          }
          if (!chosen) break;
          next = chosen.slice();
        }
        if (loop.length > 4 && loop[loop.length - 1][0] === start[0] && loop[loop.length - 1][1] === start[1]) {
          loop.pop();
          loops.push(loop);
        }
      });
    });
    if (!loops.length) return null;
    var outer = loops[0];
    var bestArea = Math.abs(polygonArea(outer));
    for (var i = 1; i < loops.length; i++) {
      var area = Math.abs(polygonArea(loops[i]));
      if (area > bestArea) { outer = loops[i]; bestArea = area; }
    }
    return outer;
  }

  function drawClosedPointPath(ctx, points, scaleX, scaleY) {
    if (!points || !points.length) return false;
    ctx.beginPath();
    ctx.moveTo(points[0][0] * scaleX, points[0][1] * scaleY);
    for (var i = 1; i < points.length; i++) ctx.lineTo(points[i][0] * scaleX, points[i][1] * scaleY);
    ctx.closePath();
    return true;
  }


  function drawSmoothClosedPointPath(ctx, points, scaleX, scaleY) {
    if (!points || points.length < 3) return drawClosedPointPath(ctx, points, scaleX, scaleY);
    var pts = points.map(function (pt) { return [pt[0] * scaleX, pt[1] * scaleY]; });
    ctx.beginPath();
    for (var i = 0; i < pts.length; i++) {
      var prev = pts[(i - 1 + pts.length) % pts.length];
      var curr = pts[i];
      var next = pts[(i + 1) % pts.length];
      var midPrev = [(prev[0] + curr[0]) / 2, (prev[1] + curr[1]) / 2];
      var midNext = [(curr[0] + next[0]) / 2, (curr[1] + next[1]) / 2];
      if (i === 0) ctx.moveTo(midPrev[0], midPrev[1]);
      ctx.quadraticCurveTo(curr[0], curr[1], midNext[0], midNext[1]);
    }
    ctx.closePath();
    return true;
  }

  function syncProofCanvasSize(canvas, stage) {
    if (!canvas || !stage) return;
    var rect = stage.getBoundingClientRect();
    var style = window.getComputedStyle(stage);
    var padX = (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
    var maxCss = Math.max(280, Math.min(rect.width - padX, 760));
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.style.width = maxCss + 'px';
    canvas.style.height = maxCss + 'px';
    var target = Math.max(1, Math.round(maxCss * dpr));
    if (canvas.width !== target || canvas.height !== target) {
      canvas.width = target;
      canvas.height = target;
    }
  }

  function drawStickerEdge(ctx, art, thickness, color, showCutLine) {
    var W = art.width, H = art.height;

    // Focused baseline fix: use a higher-resolution silhouette, then smooth just enough to get a more
    // Keep the contour even without letting tiny bumps dominate the preview.
    var silhouette = buildSimplifiedMask(art, 320);
    var pxScale = silhouette.width / W;
    silhouette = fillMaskHoles(silhouette);

    var smoothRadius = Math.max(2, Math.round(thickness * pxScale * 0.34));
    silhouette = buildClosedMask(silhouette, smoothRadius);
    silhouette = blurThresholdMask(silhouette, 1.0, 118);
    silhouette = fillMaskHoles(silhouette);

    var borderRadius = Math.max(3, Math.round(thickness * pxScale));
    var borderMask = fillMaskHoles(dilateMask(silhouette, borderRadius));
    borderMask = buildClosedMask(borderMask, Math.max(1, Math.round(borderRadius * 0.18)));
    borderMask = blurThresholdMask(borderMask, 1.0, 124);
    borderMask = fillMaskHoles(borderMask);

    var pathPoints = traceMaskOuterPath(borderMask);
    if (pathPoints && pathPoints.length > 8) {
      pathPoints = pruneCollinear(pathPoints);
      pathPoints = simplifyPathRDP(pathPoints, 1.45);
      pathPoints = chaikinClosed(pathPoints, 2);
      pathPoints = simplifyPathRDP(pathPoints, 0.95);
    }

    if (pathPoints && pathPoints.length > 8) {
      var scaleX = W / borderMask.width;
      var scaleY = H / borderMask.height;

      ctx.save();
      ctx.fillStyle = color;
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';
      drawSmoothClosedPointPath(ctx, pathPoints, scaleX, scaleY);
      ctx.fill();
      ctx.restore();

      ctx.save();
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(art, 0, 0);
      ctx.restore();

      if (showCutLine) {
        var dash = Math.max(6, W / 105);
        var gap = Math.max(4, W / 155);
        var line = Math.max(2.4, W / 210);
        ctx.save();
        drawSmoothClosedPointPath(ctx, pathPoints, scaleX, scaleY);
        ctx.clip();
        ctx.strokeStyle = '#39ff14';
        ctx.lineWidth = line;
        ctx.setLineDash([dash, gap]);
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        drawSmoothClosedPointPath(ctx, pathPoints, scaleX, scaleY);
        ctx.stroke();
        ctx.restore();
      }
      return;
    }

    // Fallback raster border if a smooth vector-like path cannot be built.
    var borderCanvas = maskCanvas(borderMask, color);
    ctx.save();
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(borderCanvas, 0, 0, borderCanvas.width, borderCanvas.height, 0, 0, W, H);
    ctx.restore();
    ctx.drawImage(art, 0, 0);

    if (showCutLine) {
      var cutOuter = dilateMask(borderMask, 1);
      var cutInner = erodeMask(borderMask, 1);
      var cutRing = subtractMask(cutOuter, cutInner);
      var cutCanvas = maskCanvasDashed(cutRing, '#39ff14');
      ctx.save();
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(cutCanvas, 0, 0, cutCanvas.width, cutCanvas.height, 0, 0, W, H);
      ctx.restore();
    }
  }

  function shapePath(ctx, shape, x, y, w, h) {
    if (shape === 'circle') {
      var size = Math.min(w, h);
      ctx.beginPath();
      ctx.arc(x + w / 2, y + h / 2, size / 2, 0, Math.PI * 2);
      ctx.closePath();
    } else if (shape === 'oval') {
      ctx.beginPath();
      ctx.ellipse(x + w / 2, y + h / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
      ctx.closePath();
    } else {
      roundedRectPath(ctx, x, y, w, h, 12);
    }
  }


  function fitRectToAspect(minW, minH, maxW, maxH, ratio) {
    var w = Math.max(minW, minH * ratio);
    var h = w / ratio;
    if (h < minH) { h = minH; w = h * ratio; }
    if (w > maxW) { w = maxW; h = w / ratio; }
    if (h > maxH) { h = maxH; w = h * ratio; }
    return { width: Math.max(1, Math.round(w)), height: Math.max(1, Math.round(h)) };
  }

  function drawGeometricCutLine(ctx, shape, x, y, w, h) {
    var offset = 2;
    ctx.save();
    ctx.strokeStyle = '#39ff14';
    ctx.lineWidth = 1.35;
    ctx.setLineDash([6, 4]);
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    shapePath(ctx, shape, x - offset, y - offset, w + offset * 2, h + offset * 2);
    ctx.stroke();
    ctx.restore();
  }

  function drawProof(showCutLine) {
    if (typeof showCutLine === 'undefined') showCutLine = true;
    if (!proofRoot) return;
    var canvas = proofRoot.querySelector('[data-proof-canvas]');
    var empty = proofRoot.querySelector('[data-proof-empty]');
    var stage = proofRoot.querySelector('[data-proof-stage]');
    if (!canvas || !stage) return;
    stage.style.backgroundColor = proofSettings.background;
    stage.classList.toggle('is-dark', proofSettings.background === '#151515');
    syncProofCanvasSize(canvas, stage);
    var ctx = canvas.getContext('2d');
    var W = canvas.width, H = canvas.height;
    ctx.clearRect(0, 0, W, H);
    if (!proofImage) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;

    var maxW = proofSettings.shape === 'edge' || proofSettings.shape === 'kiss' ? W * .89 : W * .82;
    var maxH = proofSettings.shape === 'edge' || proofSettings.shape === 'kiss' ? H * .89 : H * .82;
    var scale = Math.min(maxW / proofImage.naturalWidth, maxH / proofImage.naturalHeight);
    var baseW = Math.max(1, Math.round(proofImage.naturalWidth * scale));
    var baseH = Math.max(1, Math.round(proofImage.naturalHeight * scale));

    var source = document.createElement('canvas'); source.width = baseW; source.height = baseH;
    var sc = source.getContext('2d', { willReadFrequently: true });
    sc.imageSmoothingEnabled = true;
    sc.imageSmoothingQuality = 'high';
    sc.drawImage(proofImage, 0, 0, baseW, baseH);
    if (proofSettings.removeBackground) {
      removeMatchingBackgroundEverywhere(source, 46);
      source = fitCanvasToBox(trimCanvasToAlpha(source, 3), maxW, maxH);
    }
    if (proofSettings.removeExistingStroke) {
      var strokeAnalysis = analyzeExistingOuterStroke(source);
      if (strokeAnalysis && removeExistingOuterStroke(source, strokeAnalysis)) {
        source = fitCanvasToBox(trimCanvasToAlpha(source, 3), maxW, maxH);
      }
    }

    var dw = source.width;
    var dh = source.height;
    var dx = Math.round((W - dw) / 2), dy = Math.round((H - dh) / 2);

    var art = document.createElement('canvas'); art.width = W; art.height = H;
    var ac = art.getContext('2d'); ac.imageSmoothingEnabled = true; ac.imageSmoothingQuality = 'high'; ac.drawImage(source, dx, dy);
    // Standard uses the former Wide border. Wide is slightly thicker.
    var thickness = proofSettings.cutline === 'wide' ? 40 : 34;

    if (proofSettings.shape === 'edge') {
      drawStickerEdge(ctx, art, thickness, proofSettings.color, showCutLine);
    } else if (proofSettings.shape === 'kiss') {
      var backingPad = thickness + 30;
      ctx.save();
      ctx.fillStyle = '#ffffff';
      roundedRectPath(ctx, dx - backingPad, dy - backingPad, dw + backingPad * 2, dh + backingPad * 2, 14);
      ctx.fill();
      ctx.strokeStyle = '#d2d2d2'; ctx.lineWidth = 2; ctx.stroke();
      ctx.restore();
      drawStickerEdge(ctx, art, Math.max(7, thickness - 3), proofSettings.color, false);
    } else {
      var shape = proofSettings.shape;
      var outerX, outerY, outerW, outerH;
      if (shape === 'circle' || shape === 'square') {
        var side = Math.max(dw, dh) + thickness * 2 + 34;
        outerW = side; outerH = side;
        outerW = Math.min(outerW, W * 0.84);
        outerH = Math.min(outerH, H * 0.84);
      } else if (shape === 'oval') {
        var ovalBox = fitRectToAspect(
          dw + thickness * 2 + 38,
          dh + thickness * 2 + 18,
          W * 0.84,
          H * 0.70,
          1.42
        );
        outerW = ovalBox.width;
        outerH = ovalBox.height;
      } else {
        var rectBox = fitRectToAspect(
          dw + thickness * 2 + 40,
          dh + thickness * 2 + 14,
          W * 0.86,
          H * 0.66,
          1.56
        );
        outerW = rectBox.width;
        outerH = rectBox.height;
      }
      outerX = Math.round((W - outerW) / 2);
      outerY = Math.round((H - outerH) / 2);

      ctx.save();
      ctx.fillStyle = proofSettings.color;
      shapePath(ctx, shape, outerX, outerY, outerW, outerH);
      ctx.fill();
      ctx.restore();

      var inset = Math.max(12, thickness - 2);
      var innerX = outerX + inset;
      var innerY = outerY + inset;
      var innerW = Math.max(10, outerW - inset * 2);
      var innerH = Math.max(10, outerH - inset * 2);

      // Fit the full uploaded design inside the selected geometric shape.
      // Do not crop the artwork when Circle, Oval, Square or Rectangle are selected.
      var contentBoxX = innerX;
      var contentBoxY = innerY;
      var contentBoxW = innerW;
      var contentBoxH = innerH;
      if (shape === 'circle' || shape === 'oval') {
        contentBoxW = innerW / Math.sqrt(2);
        contentBoxH = innerH / Math.sqrt(2);
      }
      var fitScale = Math.min(contentBoxW / dw, contentBoxH / dh) * 0.985;
      var placedW = Math.max(1, Math.round(dw * fitScale));
      var placedH = Math.max(1, Math.round(dh * fitScale));
      var placedX = Math.round(innerX + (innerW - placedW) / 2);
      var placedY = Math.round(innerY + (innerH - placedH) / 2);

      ctx.save();
      shapePath(ctx, shape, innerX, innerY, innerW, innerH);
      ctx.clip();
      ctx.drawImage(source, placedX, placedY, placedW, placedH);
      ctx.restore();

      if (showCutLine) drawGeometricCutLine(ctx, shape, outerX, outerY, outerW, outerH);
    }
  }

  function updateBackgroundControl() {
    if (!proofRoot) return;
    // Background removal is automatic now, so there is no customer toggle to show.
    var control = proofRoot.querySelector('[data-proof-background-control]');
    if (control) control.hidden = true;
  }

  function setBackgroundRemoval(on) {
    proofSettings.removeBackground = !!on;
    if (!proofRoot) return;
    var btn = proofRoot.querySelector('[data-remove-background]');
    var status = proofRoot.querySelector('[data-bg-status]');
    var prop = proofRoot.querySelector('[data-proof-prop-background]');
    if (btn) { btn.classList.toggle('is-on', proofSettings.removeBackground); btn.setAttribute('aria-pressed', proofSettings.removeBackground ? 'true' : 'false'); }
    if (status) status.textContent = proofSettings.removeBackground ? 'Removed' : 'Keep original';
    if (prop) prop.value = proofSettings.removeBackground ? 'Remove solid background' : 'Keep original';
    refreshExistingStrokeDetection(true);
    drawProof();
  }

  function proofLoadFile(file) {
    if (!proofRoot) return;
    if (proofObjectUrl) { try { URL.revokeObjectURL(proofObjectUrl); } catch (e) {} proofObjectUrl = null; }
    proofImage = null;
    proofAutoBackgroundSample = null;
    proofExistingStrokeDetection = null;
    proofStrokeUserChoice = null;
    proofSettings.removeExistingStroke = false;
    updateExistingStrokeControl();
    if (!file) {
      proofRoot.hidden = true;
      setProofLauncherEnabled(false);
      closeProofModal();
      setBackgroundRemoval(false);
      drawProof();
      return;
    }
    var supported = /^image\/(png|jpeg|jpg|webp|gif|svg\+xml)$/i.test(file.type) || /\.(png|jpe?g|webp|gif|svg)$/i.test(file.name || '');
    proofRoot.hidden = false;
    setProofLauncherEnabled(true);
    var note = proofRoot.querySelector('[data-proof-note]');
    if (!supported) {
      if (note) note.textContent = 'Proof view is available for PNG, JPG and SVG files. Your uploaded file will still be attached to the order.';
      drawProof();
      openProofModal();
      return;
    }
    if (note) note.textContent = 'This proof view is for order approval. We still review every file before printing.';
    proofObjectUrl = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      proofImage = img;
      var bgSample = sampleEdgeBackgroundFromImage(img);
      proofAutoBackgroundSample = bgSample;
      if (bgSample) applyAutoBorderColor(bgSample.hex);
      else applyAutoBorderColor('#ffffff');
      setBackgroundRemoval(proofSettings.shape === 'edge');
      updateBackgroundControl();
      refreshExistingStrokeDetection(true);
      drawProof();
      if (!proofAutoOpened) { openProofModal(); proofAutoOpened = true; }
    };
    img.onerror = function () { proofImage = null; drawProof(); };
    img.src = proofObjectUrl;
  }


  // Always attach the rendered proof image when a supported artwork preview exists.
  // This keeps the customer's original Artwork file AND a separate cart/order preview.
  form.addEventListener('submit', function () {
    if (proofRoot && proofImage) captureApprovedPreview();
  });

  if (proofRoot) {
    setProofLauncherEnabled(false);
    buildProofCutStyles();
    Array.prototype.slice.call(form.querySelectorAll('[data-proof-open]')).forEach(function (b) {
      b.addEventListener('click', function () { openProofModal(); });
    });
    Array.prototype.slice.call(form.querySelectorAll('[data-proof-close]')).forEach(function (b) {
      b.addEventListener('click', function () { closeProofModal(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && proofModal && !proofModal.hidden) closeProofModal();
    });
    Array.prototype.slice.call(form.querySelectorAll('[data-proof-decision]')).forEach(function (b) {
      b.addEventListener('click', function () {
        var approved = /approved/i.test(b.dataset.proofDecision || '');
        var changeBox = form.querySelector('[data-proof-change-box]');
        var changeNote = form.querySelector('[data-proof-change-note]');
        if (approved) {
          captureApprovedPreview();
          setProofDecision(b.dataset.proofDecision, 'Saved: your sticker is approved for print.');
          if (changeBox) changeBox.hidden = true;
          closeProofModal();
        } else {
          clearApprovedPreview();
          setProofDecision(b.dataset.proofDecision, 'Tell us what you want changed before printing.');
          if (changeBox) {
            changeBox.hidden = false;
            window.requestAnimationFrame(function () {
              changeBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
              window.setTimeout(function () { if (changeNote) changeNote.focus({ preventScroll: true }); }, 220);
            });
          } else if (changeNote) {
            changeNote.focus();
          }
        }
      });
    });
    var proofSaveChanges = form.querySelector('[data-proof-save-changes]');
    if (proofSaveChanges) proofSaveChanges.addEventListener('click', function () {
      var changeNote = form.querySelector('[data-proof-change-note]');
      var outsideNote = form.querySelector('#gp-note');
      if (outsideNote && changeNote && changeNote.value.trim()) outsideNote.value = changeNote.value.trim();
      clearApprovedPreview();
      setProofDecision('Customer requested changes before printing', 'Saved: we will review your requested changes before printing.');
      closeProofModal();
    });
    Array.prototype.slice.call(form.querySelectorAll('[data-cut-style-option]')).forEach(function (chip) {
      chip.addEventListener('click', function () { syncProofShapeFromValue(chip.dataset.val, chip.dataset.previewShape); });
    });
    Array.prototype.slice.call(proofRoot.querySelectorAll('[data-proof-cutline]')).forEach(function (b) {
      b.addEventListener('click', function () {
        proofSettings.cutline = b.dataset.proofCutline;
        setProofChoice('[data-proof-cutline]', b);
        var prop = proofRoot.querySelector('[data-proof-prop-cutline]');
        if (prop) prop.value = proofSettings.cutline === 'normal' ? 'Standard' : proofSettings.cutline.charAt(0).toUpperCase() + proofSettings.cutline.slice(1);
        drawProof();
      });
    });
    Array.prototype.slice.call(proofRoot.querySelectorAll('[data-proof-color]')).forEach(function (b) {
      b.addEventListener('click', function () {
        proofSettings.color = b.dataset.proofColor;
        var customLabel = proofRoot.querySelector('[data-proof-color-custom]'); if (customLabel && customLabel.parentElement) customLabel.parentElement.classList.remove('is-on');
        setProofChoice('[data-proof-color]', b);
        var prop = proofRoot.querySelector('[data-proof-prop-color]');
        if (prop) prop.value = proofFriendlyColor(proofSettings.color);
        drawProof();
      });
    });
    Array.prototype.slice.call(proofRoot.querySelectorAll('[data-proof-bg]')).forEach(function (b) {
      b.addEventListener('click', function () {
        proofSettings.background = b.dataset.proofBg;
        setProofChoice('[data-proof-bg]', b);
        drawProof();
      });
    });
    var customColor = proofRoot.querySelector('[data-proof-color-custom]');
    if (customColor) customColor.addEventListener('input', function () {
      proofSettings.color = customColor.value;
      if (customColor.parentElement) customColor.parentElement.classList.add('is-on');
      Array.prototype.slice.call(proofRoot.querySelectorAll('[data-proof-color]')).forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
      var prop = proofRoot.querySelector('[data-proof-prop-color]'); if (prop) prop.value = proofFriendlyColor(proofSettings.color);
      drawProof();
    });
    var removeBg = proofRoot.querySelector('[data-remove-background]');
    if (removeBg) removeBg.addEventListener('click', function () { setBackgroundRemoval(!proofSettings.removeBackground); });
    var removeStroke = proofRoot.querySelector('[data-remove-existing-stroke]');
    if (removeStroke) removeStroke.addEventListener('click', function () { setExistingStrokeRemoval(!proofSettings.removeExistingStroke); });
  }

  // ---- Upload ----
  var up = form.querySelector('[data-upload]');
  if (up) {
    var dz = up.querySelector('[data-dropzone]');
    var input = up.querySelector('[data-file]');
    var card = up.querySelector('[data-filecard]');
    var thumb = up.querySelector('[data-thumb]');
    var icon = up.querySelector('[data-fileicon]');
    var nameEl = up.querySelector('[data-filename]');
    var sizeEl = up.querySelector('[data-filesize]');
    var rm = up.querySelector('[data-removefile]');
    var err = up.querySelector('[data-uploaderr]');

    function human(b) { return b < 1024000 ? Math.round(b / 1024) + ' KB' : (b / 1048576).toFixed(1) + ' MB'; }

    function show(f) {
      if (!f) { card.hidden = true; dz.hidden = false; if (typeof proofLoadFile === 'function') proofLoadFile(null); return; }
      if (f.size > 20 * 1024 * 1024) { err.classList.add('show'); err.textContent = 'That file is over 20 MB. Email it to us instead.'; input.value = ''; return; }
      err.classList.remove('show');
      nameEl.textContent = f.name;
      sizeEl.textContent = human(f.size);
      var ext = (f.name.split('.').pop() || '').toUpperCase().slice(0, 4);
      if (/^image\//.test(f.type)) {
        thumb.src = URL.createObjectURL(f); thumb.hidden = false; icon.hidden = true;
      } else {
        thumb.hidden = true; icon.hidden = false; icon.textContent = ext;
      }
      card.hidden = false; dz.hidden = true;
      if (typeof proofLoadFile === 'function') proofLoadFile(f);
    }

    input.addEventListener('change', function () { show(input.files[0]); });
    if (rm) rm.addEventListener('click', function () { input.value = ''; show(null); });
    ['dragenter', 'dragover'].forEach(function (ev) {
      dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.add('drag'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.remove('drag'); });
    });
    dz.addEventListener('drop', function (e) {
      if (e.dataTransfer.files && e.dataTransfer.files[0]) { input.files = e.dataTransfer.files; show(input.files[0]); }
    });
    dz.addEventListener('click', function (e) { if (e.target !== input) input.click(); });
    dz.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); } });
  }

})();
